// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"45":"b662880b","198":"7a77c2e0","545":"6b25f16f","759":"9b76e737","787":"f2edf0ed","867":"65891c1e"}[chunkId] + ".chunk.js";
};